"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctProperMotion = void 0;
var epoch_1 = require("../../constants/epoch");
var timeCalc_1 = require("../../time/calculations/timeCalc");
var angleCalc_1 = require("../../utils/angleCalc");
function correctProperMotion(coords, properMotion, jd, startingEpoch) {
    if (startingEpoch === void 0) { startingEpoch = epoch_1.EPOCH_J2000; }
    var t = (0, timeCalc_1.getEpochInterval)(jd, startingEpoch) * 100;
    var rightAscension = coords.rightAscension + properMotion.rightAscension * t;
    var declination = coords.declination + properMotion.declination * t;
    return {
        rightAscension: (0, angleCalc_1.normalizeAngle)(rightAscension),
        declination: declination,
        radiusVector: coords.radiusVector,
    };
}
exports.correctProperMotion = correctProperMotion;
